export default [
  {
    path: '/calendarIndex',
    name: 'calendarIndex',
    component: () => import('@/views/calendarSystem/indexNew'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/calendarChannelList',
    name: 'calendarChannelList',
    component: () => import('@/views/calendarSystem/deviceManage/channelList'),
    meta: {
      title: '渠道管理'
    }
  },
  {
    path: '/calendarMachineList',
    name: 'calendarMachineList',
    component: () => import('@/views/calendarSystem/deviceManage/machineList'),
    meta: {
      title: '机型管理'
    }
  },
  {
    path: '/calendarDeviceList',
    name: 'calendarDeviceList',
    component: () => import('@/views/calendarSystem/deviceManage/deviceList'),
    meta: {
      title: '设备管理'
    }
  },
  {
    path: '/calendarUserList',
    name: 'calendarUserList',
    component: () => import('@/views/calendarSystem/baby/userList'),
    meta: {
      title: '用户管理'
    }
  },
  {
    path: '/calendarOtaManger',
    name: 'calendarOtaManger',
    component: () => import('@/views/calendarSystem/apply/otaManger'),
    meta: {
      title: 'OTA管理'
    }
  },
  {
    path: '/calendarAppManager',
    name: 'calendarAppManager',
    component: () => import('@/views/calendarSystem/apply/appManager'),
    meta: {
      title: 'APP管理'
    }
  },
  {
    path: '/calendarOtaDownloadLogs',
    name: 'calendarOtaDownloadLogs',
    component: () => import('@/views/calendarSystem/apply/otaDownloadLogs'),
    meta: {
      title: 'OTA升级记录'
    }
  },
  {
    path: '/calendarDeviceInstruction',
    name: 'calendarDeviceInstruction',
    component: () => import('@/views/calendarSystem/deviceManage/deviceInstruction'),
    meta: {
      title: '设备指令'
    }
  },
  {
    path: '/calendarApkManager',
    name: 'calendarApkManager',
    meta: {
      title:'APK管理'
    },
    component: () => import('@/views/calendarSystem/apply/apkManager')
  },
  {
    path: '/calendarChannelAppPage',
    name: 'calendarChannelAppPage',
    component: () => import('@/views/calendarSystem/deviceManage/ChannelAppPage'),
    meta: {
      title:'渠道APP管理'
    }
  },
  {
    path: '/calendarVirtualSnLicenseList',
    name: 'calendarVirtualSnLicenseList',
    meta: {
      title: '授权许可'
    },
    component: () => import('@/views/calendarSystem/deviceManage/virtualSnLicenseList'),
  },
  {
    path: '/calendarVirtualSnBatchList',
    name: 'calendarVirtualSnBatchList',
    meta: {
      title: '授权批次'
    },
    component: () => import('@/views/calendarSystem/deviceManage/virtualSnBatchList'),
  },
  {
    path: '/calendarCheckModel',
    name: 'calendarCheckModel',
    component: () => import('@/views/calendarSystem/deviceManage/checkModel'),
    meta: {
      title:'查看机型'
    }
  },
  {
    path: '/calendar/category/index',
    name: 'calendarCategoryIndex',
    component: () => import('@/views/calendarSystem/category/index'),
    meta: {
      title: '分类管理'
    }
  },
  {
    path: '/calendar/fridgeFood/index',
    name: 'calendarFridgeFoodIndex',
    component: () => import('@/views/calendarSystem/fridgeFood/index'),
    meta: {
      title: '食物管理'
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/calendarRouter.js